module.exports = __webpack_public_path__ + "static/media/CentraNo2-Book.0f358fc3.woff2";